import React from 'react';
import { Link } from 'react-router-dom';
import Linkify from 'react-linkify';

import i18n from '../../core/i18n';

export const renderGoalStatusIcon = (type) => {
  switch (type) {
    case 'COMPLETED':
      return (
        <span className="c-checkbox-icon c-checkbox-icon--completed u-margin-right-tiny" />
      );
    case 'REMOVED':
      return (
        <span className="c-checkbox-icon c-checkbox-icon--deleted u-margin-right-tiny" />
      );
    case 'UNCOMPLETED':
    default:
      return <span className="c-checkbox-icon u-margin-right-tiny" />;
  }
};

const Item = ({ userId, goals }) => {
  const goalChanges = goals.filter((g) => g.action !== 'ADD_GOAL_MEMO');
  const goalMemos = goals.filter((g) => g.action === 'ADD_GOAL_MEMO');
  const UserWithLink = (
    <React.Fragment>
      <Link to={`/users/${userId}`} className="c-box-primary__link">
        @{goals[0].initiator && goals[0].initiator.name}
      </Link>{' '}
    </React.Fragment>
  );

  return (
    <div>
      <div key={userId} className="c-box-primary__box">
        <div className="c-box-primary__item">
          {goalChanges.length > 0 && (
            <div className="c-box-primary__text">
              <div className="u-margin-bottom">
                {UserWithLink}
                {`${i18n.t('events.goal.update')} ${goalChanges.length} `}
                {i18n.t('events.goal.label', {
                  postProcess: 'interval',
                  count: goalChanges.length,
                })}
              </div>
            </div>
          )}
          {goalChanges.map(({ data: { goal } }, i) => (
            <div
              key={goal._id}
              className={`u-display-flex u-align-items-center ${
                i === goalChanges.length - 1 ? '' : 'u-margin-bottom-tiny'
              }`}
            >
              {renderGoalStatusIcon(goal.status)}
              <span className="u-font-italic c-box-primary__text">
                {goal.name}
              </span>
            </div>
          ))}
          {goalMemos.length > 0 && (
            <div
              className={`${
                goalChanges.length > 0
                  ? 'u-border-top u-margin-top-large u-padding-top'
                  : ''
              }`}
            >
              <div className="u-margin-bottom-tiny">
                {UserWithLink}
                {i18n.t('events.goal.sharedGoalMemos')}
              </div>
              {goalMemos.map(({ data: { memo } }, i) => (
                <div
                  key={memo._id}
                  className={`u-weight-light ${
                    i + 1 !== goalMemos.length ? 'u-margin-bottom-tiny' : ''
                  }`}
                >
                  {' '}
                  <blockquote className="c-blockquote u-font-italic u-margin-top u-margin-bottom-micro display-linebreak">
                    <Linkify
                      properties={{
                        target: '_blank',
                        className: 'u-color-blue-violet',
                      }}
                    >
                      <em>{memo.content}</em>
                    </Linkify>
                  </blockquote>
                  <small>
                    {i18n.t('events.goal.sharedForGoal')}{' '}
                    <strong>{memo.goal.name}</strong>
                  </small>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Item;



// WEBPACK FOOTER //
// ./src/events/goals/Item.js